//============================================================================
// Name        : printerReducer.ts
// Purpose     : Define store Printer reducer
// Created     : 2019-07-10
// Author      : Senitron Team
// Copyright   : Copyright 2019 Senitron Corporation. All rights reserved.
//============================================================================

import {
    fetchPrinters,
    IFetchPrintersAction,
    IPrinterAction,
    ISaveDefaultPrinterAction,
    ISetPrintStateAction,
    ISetSavePrinterAction,
    ISetSelectedPrinterAction,
    saveDefaultPrinter,
    setPrintState,
    setSavePrinter,
    setSelectedPrinter} from "../actions/printerActions";
import { IPrinterOption, IPrintState, PrinterActions } from "../types";

const initialState: IPrintState = {
    items:               new Array<IPrinterOption>(),
    savePrinter:         true,
    defaultPrinter:      null,
    selectedPrinter:     null,

    // Printing state
    palletCount:         0,
    caseCount:           0,
    detectedPalletCount: 0,
    detectedCaseCount:   0,
    printing:            false
};

export default function(state: IPrintState = initialState, action: IPrinterAction) {
    switch (action.type) {

        //====================================================================
        // Map Actions messages to Action functions
        //====================================================================

        case PrinterActions.FetchPrinters:      return fetchPrinters(state, action as IFetchPrintersAction);
        case PrinterActions.SetSavePrinter:     return setSavePrinter(state, action as ISetSavePrinterAction);
        case PrinterActions.SaveDefaultPrinter: return saveDefaultPrinter(state, action as ISaveDefaultPrinterAction);
        case PrinterActions.SetSelectedPrinter: return setSelectedPrinter(state, action as ISetSelectedPrinterAction);
        case PrinterActions.SetPrintState:      return setPrintState(state, action as ISetPrintStateAction);

        //====================================================================

        default:
            return state;
    }
}
